import { IsISO8601, Matches } from 'class-validator';

export class ExtendSurveyInviteDto {
  /**
   * Istante ISO 8601 completo (con `T`): `IsISO8601` accetta anche la sola data, che
   * qui sarebbe ambigua sul fuso. Il tetto di 21 giorni dalla creazione lo applica il service.
   */
  @IsISO8601({ strict: true, strictSeparator: true })
  @Matches(/^\d{4}-\d{2}-\d{2}T/)
  expiresAt!: string;
}
